// İş ekipmanı belgesi için önizleme içi onay/red paneli
import { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { DocReviewPanel } from './DocReviewPanel';
import { validityBlockMessage } from '../../lib/helpers';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const EquipmentDocPanel = ({ equipment, docKey, docLabel, templates = [], operatorList = [], onSaved, endDate }) => {
  const docs = equipment.documents || {};
  const isOperator = docKey === 'operatorluk_belgesi';
  const isPeriodic = docKey === 'periyodik_muayene';
  const [operatorName, setOperatorName] = useState(docs.operatorluk_belgesi_name || '');
  const [date, setDate] = useState(docs[`${docKey}_date`] || docs[`${docKey}_validity`] || '');
  const hasValidity = isPeriodic || isOperator;
  const dateError = hasValidity ? validityBlockMessage(date, endDate) : null;

  const save = async (changes, message) => {
    try {
      const res = await axios.patch(`${API}/equipment/${equipment.id}/documents`, { documents: changes });
      toast.success(message);
      onSaved(res.data);
    } catch (err) {
      const d = err.response?.data?.detail;
      toast.error(typeof d === 'string' ? d : 'Güncelleme başarısız');
    }
  };

  const extra = isOperator ? { operatorluk_belgesi_name: operatorName || null } : {};

  return (
    <DocReviewPanel
      approved={docs[docKey] === 'onay'}
      docLabel={docLabel}
      initialDate={docs[`${docKey}_date`] || docs[`${docKey}_validity`] || ''}
      dateLabel={isPeriodic || isOperator ? 'Geçerlilik tarihi' : null}
      dateRequired={isPeriodic || (isOperator && operatorList.length > 0)}
      onDateChange={setDate}
      dateError={dateError}
      templates={templates}
      approveDisabled={isOperator && operatorList.length > 0 && !operatorName}
      onApprove={(date) => save({ [docKey]: 'onay', [`${docKey}_note`]: '', [`${docKey}_deficiencies`]: [], [`${docKey}_date`]: date || null, [`${docKey}_validity`]: date || null, ...extra }, `${docLabel} onaylandı`)}
      onNotApplicable={() => save({ [docKey]: 'kapsam_disi', [`${docKey}_note`]: '', [`${docKey}_deficiencies`]: [] }, `${docLabel} kapsam dışı olarak işaretlendi`)}
      onReject={({ deficiencies, reason }) => save({ [docKey]: 'eksik', [`${docKey}_deficiencies`]: deficiencies, [`${docKey}_note`]: reason || deficiencies.join(', '), [`${docKey}_date`]: null, [`${docKey}_validity`]: null, ...extra }, `${docLabel} reddedildi`)}
    >
      {isOperator && operatorList.length > 0 && (
        <div className="space-y-1">
          <label className="text-xs text-slate-500">Operatör belgesi *</label>
          <select
            value={operatorName} onChange={(e) => setOperatorName(e.target.value)}
            className="h-8 w-full rounded-md border border-slate-200 bg-white px-2 text-xs"
            data-testid="doc-decision-operator-select"
          >
            <option value="">Seçin...</option>
            {operatorList.map(op => <option key={op.name} value={op.name}>{op.name}</option>)}
          </select>
        </div>
      )}
    </DocReviewPanel>
  );
};
